import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../lib/constants';
import { trackInitiateCheckout } from '../lib/pixel';
type FloatingCtaProps = {
  /** Id of the element after which the floating CTA should appear. */
  triggerId: string;
};
export function FloatingCta({
  triggerId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById(triggerId);
    if (!target) return;
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      // Show once the first CTA has been scrolled past.
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(target);
    const onScroll = () => {
      const rect = target.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  }, [triggerId]);
  return <AnimatePresence data-id="element-70" data-mp="21buiakzcmiom">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 26
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-71" data-mp="26bqp0rzfko7v">
          <div className="mx-auto w-full max-w-md rounded-2xl bg-navy-950/95 p-2 shadow-2xl backdrop-blur" data-id="element-72" data-mp="1wb6mlm06ddo2">
            <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="animate-shake-cta flex w-full items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-3.5 text-center text-[13px] font-extrabold uppercase tracking-wide text-navy-950 shadow-lg transition-colors hover:bg-gold-400 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/60 sm:text-[15px]" data-id="element-73" data-mp="1ncuzhtyioy0d">
              <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-74" data-mp="3b9uc6rqbjgy0" />
              Quiero el Sistema por USD 12.99
            </a>
            <p className="mt-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.12em] text-gold-400" data-id="element-75" data-mp="36ddo1xj4d2kx">
              Acceso inmediato · Pago único · Garantía 7 días
            </p>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}